<template>
  <div style="height: 100%;width: 100%">
        <el-header>
          <el-form :model="formData" label-width="10px">
            <el-row>
              <el-form-item>
                <el-select v-model="formData.wuJianId" style="width:200px ;"  @change="renderAllEcharts" clearable placeholder="物件名称">
                  <el-option
                      v-for="item in wuJianNames"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker v-model="formData.day"  @change="renderAllEcharts" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                                placeholder="选择月份" :clearable="false"/>
              </el-form-item>
              <el-form-item>
                <el-select v-model="formData.type" @change="renderAllEcharts" clearable placeholder="类型" style="width: 100px">
                  <el-option
                      v-for="item in typeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="searchLoading" @click="getZuliActualProduction">搜索</el-button>
              </el-form-item>
            </el-row>
          </el-form>
          <!--<el-button type="primary" plain style="width: 80px" :loading="exportLoading" @click="exportProduction">导出</el-button>-->
        </el-header>

        <div>
          <div class="divSize" v-loading="zuliProductionOutputLoading" element-loading-text="数据加载中"
               style="width: 100%;height: 300px;" id="zuliProductionOutput"/>
        </div>

        <el-table :data="tableData" border style="width: 100%;height:78%;margin-top: 10px" :header-cell-style="headerCellStyle">
          <el-table-column prop="wujian_name" label="物件" width="200" fixed/>
          <el-table-column v-for="item in dayList" :key="item" :label="item.day" width="80" >
            <el-table-column label="计划" width="70">
              <template v-slot="scope" >
                <div v-for="day in scope.row.actualList" :key="day">
                  <div :style="planCellStyle(day.plan)" style="height: 100%;width: 100%"  v-if="day.date == item.date">{{ day.plan===undefined?'&nbsp;':day.plan.toLocaleString() }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :prop="item" label="实绩" width="70">
              <template v-slot="scope">
                <div v-for="day in scope.row.actualList" :key="day">
                  <div :style="actualCellStyle(day.produce_num)" v-if="day.date == item.date">{{ day.produce_num===undefined?'&nbsp;':day.produce_num.toLocaleString() }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "AssemblyProduceAchievementUnitNum",
  components: {},
  data() {
    return {
      activeName: 'unitNum',
      wuJianNames: [],
      formData: {
        day: this.getDateFormat(),
        wuJianId: '',
        type:''
      },
      searchLoading: false,
      resetLoading: false,
      exportLoading: false,
      dayList: [],
      tableData: [],
      typeList:[{value:'plan',label:'计划'}, {value:'actual',label:'实绩'}, {value:'difference',label:'差异'},],
      total: 0,
      pageNo: 1,
      //物件日生产生产实绩
      zuliProductionOutput: {
        // title: [
        //   {
        //     text: '组立生产实绩',
        //     left: '50%',
        //     textAlign: 'center'
        //   },],
        tooltip: {
          trigger: 'axis',
          type: 'shadow',
          formatter: function (params) {
            let res = ''
            let dataIndex = 1
            let res1 = ''
            let plan = true
            let isShow = false
            let dataIndex1 = 1
            let plan1 = true
            let isShow1 = false
            for (const item of params) {
              if (params.length === params[params.length -1].componentIndex +1){
                if (item.seriesName == '累计计划' || item.seriesName == '累计实绩'){
                  res += ` <span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value + ' '}`
                }else {
                  if (dataIndex % 3 === 0) {
                    res1 += ` <span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> 差异 : ${item.value + ' '}<br/>`
                  } else if (dataIndex % 2 === 0) {
                    if (item.value === 0 && !plan){
                      isShow = true
                    }
                    res1 += ` <span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> 实绩: ${item.value + ' '}`
                  } else if (dataIndex % 1 === 0) {
                    if (item.value === 0){
                      plan = false
                    }
                    res1 += ` <span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName}- 计划 : ${item.value + ' '}`
                  }
                }
                if (dataIndex === 3) {
                  if (!isShow){
                    res += res1
                  }
                  res1 = ''
                  plan = true
                  isShow = false
                  dataIndex = 0
                }
                dataIndex++
              }else {
                if (item.seriesName == '累计计划' || item.seriesName == '累计实绩'){
                  res += ` <span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName} : ${item.value + ' '}`
                }else {
                  if (dataIndex1 % 2 === 0) {
                    if (item.value === 0 && !plan1){
                      isShow1 = true
                    }
                    res1 += ` <span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> 实绩: ${item.value + ' '}<br/>`
                  } else if (dataIndex1 % 1 === 0) {
                    if (item.value === 0){
                      plan1 = false
                    }
                    res1 += ` <span style="background: ${item.color}; height:10px; width: 10px; border-radius: 50%;display: inline-block;margin-right:10px;"></span> ${item.seriesName}- 计划 : ${item.value + ' '}`
                  }
                  if (dataIndex1 === 2) {
                    if (!isShow1){
                      res += res1
                    }
                    res1 = ''
                    plan1 = true
                    isShow1 = false
                    dataIndex1 = 0
                  }
                }
                dataIndex1++
              }
            }
            return `${params[0].name} <br/>` + res
          },
          axisPointer: {
          }
        },
        legend: {
          type: 'scroll',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              interval: 0
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'套数',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name:'累计套数',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
        ],
        series: []
      },
      zuliProductionOutputLoading: false,
    }
  }, methods: {
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    renderAllEcharts(){

      //计划实绩表格
      this.getZuliActualProduction()
      //计划实绩图表
      this.getActualProductionData()

    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/wujianPlan/getWujianName');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },
    //计划实绩表格
    getZuliActualProduction() {
      this.searchLoading = true;
      this.$axios.post('mfg/zuliProductive/getZuliActualProduction', this.formData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.tableData = res.data.actualDataList
          this.dayList = res.data.dayList
          this.searchLoading = false;
        }
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },

    //计划实绩图表
    async getActualProductionData() {
      this.zuliProductionOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliActualProduction/getActualProductionData', this.formData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.zuliProductionOutput.xAxis[0].data = res.data.xAxis
        this.zuliProductionOutput.series = res.data.planActualList
        this.zuliProductionOutput.legend.data = res.data.planActualList
        let array = res.data.planActualList
        let total = []
        for (let key in array) {
          array[key].data.forEach((value, index) => {
            if (value >= 0) {
              if (this.isBlank(total[index])) {
                total[index] = 0
              }
              total[index] += Math.ceil(value)
            }
          })
        }

        this.zuliProductionOutput.yAxis[0].min = -Math.ceil(Math.max(...total)/10)*10
        this.zuliProductionOutput.yAxis[0].max = Math.ceil(Math.max(...total)/10)*10
        this.zuliProductionOutput.yAxis[0].interval = Math.round(this.zuliProductionOutput.yAxis[0].max*2/10*10)/10

        this.zuliProductionOutput.yAxis[1].min =-Math.ceil(res.data.max/10)*10
        this.zuliProductionOutput.yAxis[1].max = Math.ceil(res.data.max/10)*10
        this.zuliProductionOutput.yAxis[1].interval = Math.round(this.zuliProductionOutput.yAxis[1].max*2/10*10)/10

        this.zuliProductionOutput.series.push(res.data.cumulativePlanData)
        this.zuliProductionOutput.series.push(res.data.cumulativeActualData)

      }
      this.renderEcharts('zuliProductionOutput', this.zuliProductionOutput)
      this.zuliProductionOutputLoading = false
    },

    isBlank(val){
      if(val == null || val === ""){
        return true;
      }
    },
    exportProduction() {
      this.exportLoading = true;
      let exportDate = {tableDate: this.tableData, countDayList: this.countDayList}
      this.$axios.post('mfg/zuliProductive/exportProduction', exportDate).then(response => {
        this.exportLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("导出失败" + res.message);
        }

        console.log("res:==", res)
        const url = res.data.data.url;
        const originalName = res.data.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
        return this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    planCellStyle(data) {
      let cellStyle = 'background-color:#FFFF0080;'

      if (data < 0){
        cellStyle = 'background-color:lightcoral;color:white'
      }
      if (data === undefined){
        cellStyle = 'background-color:white'
      }
      return cellStyle
    },
    actualCellStyle(data) {
      let cellStyle = 'background-color:#4b8de4;color:white'

      if (data < 0){
        cellStyle = 'background-color:lightcoral;color:white'
      }
      if (data === undefined){
        cellStyle = 'background-color:white'
      }

      return cellStyle
    },
    headerCellStyle({column}) {
      let headerCellStyle;

      if (column.label == "计划"){
        headerCellStyle = {color: 'orange'};
      }
      if (column.label == "实绩") {
        headerCellStyle = {color: 'blue'}
      }
      return headerCellStyle;
    },
  },
  mounted() {
    //计划实绩图表
    this.getActualProductionData()
    //计划实绩表格
    this.getZuliActualProduction()
  },
  created() {
    this.getWuJianInFo()

  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0
}

.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}

.el-table :deep(.cell){
  padding: 0px;
}
.el-table :deep(.el-table__cell) {
  padding: 1px;
}
</style>